export default "__VITE_ASSET__DqiemQtc__"